import PostItem from "../PostItem/PostItem.js";
import "./Posts.scss";
import React from "react";

const Posts = ({ topPosts, subreddits: sr, keyword }) => {
  return (
    <section className="posts">
      <div className="kwdashboard__title-container">
        <h2 className="overview__title">Top {topPosts.length} Posts</h2>
      </div>
      {topPosts.map((post, i) => {
        return (
          <React.Fragment key={i}>
            <PostItem post={post} sr={sr} keyword={keyword} i={i} />
          </React.Fragment>
        );
      })}
    </section>
  );
};

export default Posts;
